define([
    'underscore',
    'edge/platform/base/BaseCtrl',
    'exports?phoneUtils!libphonenumber', // without 'exports' doesn't export a variable when is loaded as a module
], (_, BaseCtrl, phoneUtils)=> {
    const fn = ($scope, $window, LocaleService, $stateParams, EventHub)=> {
        const ctrl = Object.create(BaseCtrl);

        ctrl.init = ()=> {
            $scope.submission = $stateParams.quoteSummary;

            $scope.chosenQuote = _.findWhere($scope.submission.quoteData.offeredQuotes, {publicID: $scope.submission.bindData.chosenQuote});
            $scope.chosenPlan = _.findWhere($scope.submission.bindData.paymentPlans, {billingId: $scope.submission.bindData.selectedPaymentPlan});

            $scope.accountHolderAddress = $scope.submission.draftData.policyAddress;
            $scope.accountHolder = $scope.submission.draftData.accountHolder;
            $scope.accountHolder.contactNumber = $scope.accountHolder.homeNumber; // alternative if we need to use primary contact number this._contactNumber();
            EventHub.publish('journey', 'purchase', ctrl.createPurchaseEvent());
        };

        ctrl.createPurchaseEvent = () => {
            const submission = $scope.submission;
            const bindData = submission.bindData;
            const chosenQuote = $scope.chosenQuote;
            return {
                id: submission.quoteID,
                accountNumber: bindData.accountNumber,
                policyNumber: bindData.policyNumber,
                offering: chosenQuote.branchName,
                taxes: chosenQuote.taxes,
                total: chosenQuote.total,
                totalBeforeTaxes: chosenQuote.totalBeforeTaxes,
                productName: submission.draftData.productName,
                paymentPlans: bindData.paymentPlans,
            };
        };

        ctrl.printQuote = ()=> {
            $window.print();
        };

        ctrl._contactNumber = ()=> {
            const acctHolder = $scope.submission.draftData.accountHolder;
            const phoneType = acctHolder.primaryPhoneType;
            if (phoneType === null) {
                return;
            }

            let number;
            if (phoneType === 'work') {
                number = acctHolder.workNumber;
            } else if (phoneType === 'home') {
                number = acctHolder.homeNumber;
            } else if (phoneType === 'mobile') {
                number = acctHolder.cellNumber;
            }
            if (number === null) {
                return;
            }

            return phoneUtils.formatNational(number, LocaleService.getConfiguredPhoneRegion());
        };


        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$window', 'LocaleService', '$stateParams', 'EventHub'];
    return fn;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/controllers/ConfirmationCtrl.js